<template>
    <div>
        <v-layout row wrap justify-center>
              <v-flex xs12 sm7 md7 >
                  <dialogos-app :dialogos="dialogosRegion" tucan="0"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4>
                <v-flex xs7 sm4 md4 class="cont-img">
                <img :src="require('@/assets/presentacion/diap-9-1.png')" alt="" class="hvr" @click="openModalVideo()">
              </v-flex>
                <v-flex xs12 sm3 md3 mt-3 text-xs-left>
                    <img :src="require('@/assets/presentacion/diap-1-2.svg')" alt="">
                    <p class="animated fadeIn text-mt">O Instituto de Cultura Brasil-Colômbia foi criado pela Embaixada do Brasil em 1995 e, ao longo dos anos, se converteu na porta de entrada dos colombianos para o Brasil. No IBRACO, língua e cultura não se separam.</p>
                </v-flex>
        </v-layout> 
        <!-- MODAL VIDEO -->
        <modal-video-app v-model="modalvideo" :fullscreen="true">
            <template slot="modaltittle">
                <h1 class="modal-icon-title"></h1>
            </template>
            <v-layout justify-center wrap>
                <video :src="url" buffered controls 
                       :width="widthVideo" 
                       controlslist="nodownload"
                ></video>
                <figcaption class="white-text mt-2"> Vídeo gravado pelo IBRACO. </figcaption>
            </v-layout>
        </modal-video-app>    
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosRegion:[
                'O IBRACO é o Centro Cultural do Brasil na Colômbia.'
            ],
            widthVideo:'100%',
            url:  'videos/ibraco-presentacion-5.mp4',
            modalvideo: false
        }
    },
    methods:{
        openModalVideo(){
            this.modalvideo = true
            console.log('modalvideo')
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/globals';
.text-mt{
    margin-top: 10px;
}
.white-text{
    color: white;
}
.cont-img{
    img{
        width: 80%;
    }
}
</style>